import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Icon } from "src/components";
import { UserEntity } from "./CSVUserForm.component";
import _ from "lodash";

type AllProps = {
  users: Map<string, UserEntity>;
  validate_email: string[];
  deleteFunction: Function;
};

// Description: Displays the different tables of the CSV upload card. (Valid, Invalid, Duplicate, etc)
function CSVUserDisplayComponent(props: AllProps) {
  const { users, validate_email, deleteFunction } = props;

  return <div className="table-display">
    <Row className="header-card-row ">
      <h5 className="m-0"> Users to be created </h5>
    </Row>
    <div className="table-body">
      {_.map(validate_email, (user_id: string, index: number) => {
        const user = users.get(user_id);
        if (!user) return null;
        return (
          <Row key={index}>
            <Col xs={7}>
              <p className="font-size-sm">{user.email_address}</p>
            </Col>
            <Col xs={4}>
              <p className="m-0">{user.display_name}</p>
            </Col>
              <Col xs={1}>
                <Button 
                  variant="icon"
                  size="sm"
                  title="Delete User"
                  data-tooltip-id="pv-tooltip"
                  data-tooltip-content="Delete User"
                  onClick={() => deleteFunction(user.email_address)}
                >
                  <Icon className="ficon-x" />
                </Button>
              </Col>
          </Row>
        );
      })}
    </div>
  </div>;
}

export default React.memo(CSVUserDisplayComponent);
